import React from 'react';
import { DatePicker, Input, Modal, Radio, Select, Slider, Icon } from 'antd';
import { defineMessages, FormattedMessage } from 'react-intl';
import SearchView from './SearchView';
import moment from 'moment';
import { routerRedux } from 'dva/router';
import MoreMeeting from './MoreMeeting';
import { CALENDAR_TIME_TYPE, CHINESE, PATHS, ROLES_KEY } from '../../utils/constants';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const { Option } = Select;
const valueMap = { M: 2, w: 2, d: 1 };
const message = defineMessages({
  w: {
    id: 'time_format_w'
  },
  M: {
    id: 'time_format_M'
  },
  d: {
    id: 'time_format_d'
  }
});

class Index extends React.Component {
  constructor(props) {
    super(props);
  }

  conversionType = type => {
    return valueMap[type];
  };

  //切换日历视图
  onChangeType = e => {
    if (this._unSelect) {
      this._unSelect();
      this._unSelect = null;
    }
    this.props.dispatch({type: 'meeting/update', payload: {timeType: e.target.value}});
    let searchInfo = {
      pageNo: 1,
      startTime: moment()
        .startOf('day')
        .valueOf(),
      type: this.conversionType(e.target.value)
    };
    if (CALENDAR_TIME_TYPE.week == e.target.value) {
      searchInfo.roomIds = '';
    } else if (CALENDAR_TIME_TYPE.day == e.target.value) {
      this.props.dispatch({
        type: 'meeting/setShowTime',
        timeInfo: moment(searchInfo.startTime).locale(this.props.intl.locale)
      });
    }
    this.props.dispatch({
      type: 'meeting/getCalenderData',
      filter: searchInfo
    });
  };

  //点击日历试图新建会议
  clickHandleByDay = (time, roomID, unSelect) => {
    const { timeType } = this.props.calendar;
    if (this._unSelect) {
      this._unSelect();
    }
    let roomInfo = null;
    this._unSelect = unSelect;
    let beginTime = moment().startOf('day');
    if (moment(time).isBefore(beginTime)) {
      const { intl } = this.props;
      Modal.info({
        content: intl.formatMessage({id: 'time_expired'}),
        okText: intl.formatMessage({id: 'dialog_btn_ok'})
      });
      return;
    }
    this.props.dispatch({
      type: 'meeting/setShowTime',
      timeInfo: moment(time).locale(this.props.intl.locale)
    });
    if (timeType === CALENDAR_TIME_TYPE.week || roomID == '') {
      this.props.dispatch({type: 'meeting/update', payload: {timeType: CALENDAR_TIME_TYPE.day}});
      const serachInfo = {
        roomIds: roomID,
        type: this.conversionType(CALENDAR_TIME_TYPE.day),
        pageNo: 1
      };
      this.props.dispatch({
        type: 'meeting/getCalenderData',
        filter: serachInfo
      });
    } else {//日视图模式
      if (timeType === CALENDAR_TIME_TYPE.day) {
        roomInfo = { time: time, room: { id: roomID } };
      } else {
        const now = moment();
        const gap = 15 - (now.minute() % 15);
        const start = moment(time)
          .hour(now.hour())
          .minute(now.minute())
          .add(gap, 'minutes');
        roomInfo = { time: start, room: { id: roomID } };
      }
      this.props.dispatch({
        type: 'meetingInfo/updateRoomInfo',
        payload: roomInfo
      });
      this.props.dispatch(routerRedux.push(PATHS.meetingInfo));
    }
  };

  // 检查是否显示会控功能入口按钮
  checkCmmaFlag = meeting => {
    const {
      cmmaMeeting,
      creatorId,
      status,
      signTime,
      startTime,
      meetingCtrl: { conferenceId }
    } = meeting;
    if (cmmaMeeting !== 1) return false;
    const {userInfo = {}} = this.props;
    const {userId = "", roleKey = ''} = userInfo;
    // 会议开始前指定时间范围内，可以看到会控按钮
    const allowCtrl =
      (startTime - new Date(Date.now())) / (1000 * 60) <= signTime;
    const hasCmmaId = conferenceId && conferenceId !== '';
    // 先决条件
    if (creatorId === userId || roleKey === ROLES_KEY.room_admin) {
      if (
        (status === 0 && allowCtrl) || // 会议未开始
        status === 1 || // 会议正在进行
        (status === 2 && hasCmmaId) || // 会议已结束
        (status === 3 && hasCmmaId) // 会议已取消
      ) {
        return true;
      }
    }
    return false;
  };

  cancelMeetingConfirm = reservation => {
    const { dispatch, intl } = this.props;
    const $this = this;
    const message = (
      <span>
        <input
          style={{ float: 'left', marginTop: '3px' }}
          defaultValue="false"
          type="checkbox"
          ref={ref => {
            this.loopCheckBox = ref;
          }}
        />{' '}
        &nbsp;
        <span>
          {intl.formatMessage({ id: 'cancel_loop_meeting' })}
        </span>
      </span>
    );
    if (reservation.type > 0) {
      Modal.confirm({
        content: message,
        cancelText: intl.formatMessage({ id: 'btn_close' }),
        onOk: () => {
          let type = reservation.type;
          if ($this.loopCheckBox && !$this.loopCheckBox.checked) {
            type = 0;
          }
          dispatch({
            type: 'meeting/cancerMeeting',
            filter: { meetingId: reservation.id, type: type }
          });
        }
      })
    } else {
      Modal.confirm({
        content: intl.formatMessage({ id: 'cancel_normal_meeting' }),
        cancelText: intl.formatMessage({ id: 'btn_close' }),
        onOk: () => {
          dispatch({
            type: 'meeting/cancerMeeting',
            filter: { meetingId: reservation.id, type: reservation.type }
          });
        }
      })
    }
  }

  //取消会议具体方法
  clickCancelHandle = reservation => {
    const { dispatch, intl } = this.props;
    const cmmaFlag = this.checkCmmaFlag(reservation);
    if (cmmaFlag) {
      const promise = new Promise((resolve, reject) => {
        dispatch({
          type: 'meetingControl/checkCmmaStatus',
          resolve,
          reject,
          payload: reservation.id
        })
      });
      promise.then(
        (data) => {
          if (data) {
            Modal.confirm({
              title: intl.formatMessage({
                id: 'meeting_cancel_cmma_title'
              }),
              content: intl.formatMessage({
                id: 'meeting_cancel_cmma_text'
              }),
              okText: intl.formatMessage({id: 'dialog_btn_know'}),
              cancelText: intl.formatMessage({
                id: 'mc_btn_cancel'
              }),
              onOk: () => {
                this.cancelMeetingConfirm(reservation)
              }
            })
          } else {
            this.cancelMeetingConfirm(reservation)
          }
        },
        () => {
          this.cancelMeetingConfirm(reservation)
        }
      );
    } else {
      this.cancelMeetingConfirm(reservation)
    }
  };

  //切换日期方法
  computationTime = number => {
    const { dispatch, calendar } = this.props;
    const { timeType } = calendar;
    dispatch({
      type: 'meeting/setShowTime',
      timeInfo: moment(calendar.showTime)
        .add(number, timeType)
        .locale(this.props.intl.locale)
    });
    const serachInfo = {
      type: this.conversionType(timeType),
      pageNo: calendar.calenderMeetingData.pageNo
    };
    dispatch({ type: 'meeting/getCalenderData', filter: serachInfo });
  };

  //日历界面点击事件入口
  createMeetingHandle = ({ type, reservation }) => {
    //查看会议
    if (type === 1) {
      this.props.dispatch(
        routerRedux.push({
          pathname: PATHS.meetingInfo,
          query: { meetingId: reservation.id, operateType: 1 }
        })
      );
    }
    //修改会议
    if (type === 2) {
      const { dispatch } = this.props;
      if (reservation.type > 0) {
        let message = (
          <span>
            <input
              style={{ float: 'left', marginTop: '3px' }}
              defaultValue="false"
              type="checkbox"
              ref={ref => {
                this.loopCheckBoxEdit = ref;
              }}
            />{' '}
            &nbsp;
            <span>
              {this.props.intl.formatMessage({ id: 'modify_loop_meeting' })}
            </span>
          </span>
        );
        const $this = this;
        Modal.confirm({
          content: message,
          onOk: () => {
            let reType = 1;
            if ($this.loopCheckBoxEdit && !$this.loopCheckBoxEdit.checked) {
              reType = 0;
            }
            dispatch(
              routerRedux.push({
                pathname: PATHS.meetingInfo,
                query: { meetingId: reservation.id, reType: reType }
              })
            );
          }
        });
      } else {
        dispatch(
          routerRedux.push({
            pathname: PATHS.meetingInfo,
            query: { meetingId: reservation.id, reType: 0 }
          })
        );
      }
    }
    //取消
    if (type === 3) {
      this.clickCancelHandle(reservation);
    }
  };

  clickDeviceItem = value => {
    this.props.dispatch({
      type: 'meeting/getCalenderData',
      filter: { deviceIds: value.join(';'), pageNo: 1 }
    });
  };

  render() {
    const { showTime, holidays = [], searchInfo, timeType } = this.props.calendar;
    const {
      intl,
      topData,
      zoneTree,
      account: { meetingPolicy = { cmmaMeetingState: 1 } }
    } = this.props;
    const locale = intl.locale;

    const { devicesList = [], meetingSearchInfo } = topData;
    const {
      peopleNum = 1,
      moreZones = []
    } = meetingSearchInfo;

    const devicesOptions = [];
    devicesList &&
      devicesList.forEach(item => {
        let itemName = item.nameEn;
        if (intl.formatMessage({ id: 'locale' }) === CHINESE) {
          itemName = item.name
        }
        devicesOptions.push(
          <Option key={item.id}>{itemName}</Option>
        );
      });

    const marks = { 1: '1', 25: '25', 50: '50' };
    const formatter = value => (
      <span className="meeting-people-tooltip">
        {value + intl.formatMessage({ id: 'user_group_unit' })}
      </span>
    );

    return (
      <div className="meeting-top-search">
        <div className="container-left container-search">
          <div className="message-body">
            <div className="messages-list meeting-search">
              <div className="search-cont">
                <div className="search-cont-left">
                  <div className="meeting-device">
              <span className="menu-border">
                <label>
                  {intl.formatMessage({ id: 'meeting_search_device' })}:
                </label>
                <div className="device-item-area">
                  <Select
                    allowClear
                    mode="multiple"
                    placeholder={intl.formatMessage({ id: 'pls_select_device' })}
                    onChange={(value)=>{
                      this.clickDeviceItem(value)
                    }}
                  >
                    {devicesOptions}
                  </Select>
                </div>
              </span>
                  </div>
                  <div className="meeting-people">
              <span className="menu-border">
                <label>
                  {intl.formatMessage({ id: 'main_meeting_attends' })}:
                </label>
                <div
                  className="device-people-area"
                >
                  <Slider
                    min={1}
                    max={50}
                    marks={marks}
                    tipFormatter={formatter}
                    defaultValue={window.location.pathname === 'meeting' ? peopleNum : 1}
                    onAfterChange={v => {
                      this.props.dispatch({
                        type: 'top/setMeetingSearchInfo',
                        meetingSearchInfo: {
                          ...meetingSearchInfo,
                          peopleNum: v
                        }
                      });
                      this.props.dispatch({
                        type: 'meeting/getCalenderData',
                        filter: { peopleNum: v, pageNo: 1 }
                      });
                    }}
                  />
                </div>
              </span>
                  </div>
                </div>
                <div className="search-cont-right">
                  <div className="search-input">
              <span className="menu-border">
                <div className="meeting-room-input">
                  {/*<i className="iconfont icon-sousuo"/>*/}
                  <MoreMeeting
                    meetingTree={zoneTree}
                    intl={intl}
                    showRooms={false}
                    treeDefaultExpandAll={true}
                    selected={moreZones}
                    onMeetingChange={v => {
                      this.props.dispatch({
                        type: 'top/setMeetingSearchInfo',
                        meetingSearchInfo: {
                          ...meetingSearchInfo,
                          moreZones: v
                        }
                      });
                      this.props.dispatch({
                        type: 'meeting/getCalenderData',
                        filter: { zoneIds: v.join(';'), pageNo: 1 }
                      });
                    }}
                  />
                </div>
              </span>
                  </div>
                  <div className="search-name">
                    <Input.Search
                      onChange={e => {
                        this.props.dispatch({
                          type: 'meeting/updateSearchInfo',
                          roomName: e.target.value
                        });
                      }}
                      onSearch={value => {
                        this.props.dispatch({
                          type: 'meeting/getCalenderData',
                          filter: { roomName: value, pageNo: 1 }
                        });
                      }}
                      placeholder={intl.formatMessage({ id: 'report_pls_name' })}
                    />
                  </div>
                </div>
              </div>
              <div className="messages-title">
                <div className="calendar-type-switch">
                  <RadioGroup
                    onChange={this.onChangeType}
                    value={timeType}
                  >
                    <RadioButton value={CALENDAR_TIME_TYPE.day}>
                      <FormattedMessage id="time_type_day" />
                    </RadioButton>
                    <RadioButton value={CALENDAR_TIME_TYPE.week}>
                      <FormattedMessage id="time_type_week" />
                    </RadioButton>
                  </RadioGroup>
                </div>
                {showTime && <span className='title-time'>
                     <Icon type="caret-left" style={{lineHeight:"28px",color:"#4680FF",cursor:"pointer"}} onClick={() => this.computationTime(-1)}/>
                     {false && showTime.locale(locale).format(intl.formatMessage(message[timeType]))}
                  <DatePicker style={timeType==CALENDAR_TIME_TYPE.day?{width:"185px"}:{width:"120px"}} format={intl.formatMessage(message[timeType])} allowClear={false} value={showTime} onChange={
                    value => {
                      let format = 'YYYY-MM-DD';
                      let formatTime = value.locale(locale).format(format);
                      let newValue = moment(formatTime,format);
                      this.clickHandleByDay(newValue,'',null);
                    }
                  } />
                    <Icon type="caret-right" style={{lineHeight:"28px",color:"#4680FF",cursor:"pointer"}} onClick={() => this.computationTime(1)}/>
                </span>}
                <div className="create-btns">
                  <span
                    className="create-btn normal-meeting"
                    onClick={() => {
                      this.props.dispatch({
                        type: 'meetingInfo/set',
                        payload: { onlyVideo: 1, meeting: {} }
                      });
                      const {roomIds = ""} = searchInfo;
                      if(roomIds){//选定会议室之后，点击新建普通会议时，带入会议室id
                        const roomInfo = { room: { id: roomIds } };
                        this.props.dispatch({
                          type: 'meetingInfo/updateRoomInfo',
                          payload: roomInfo
                        });
                      }
                      this.props.dispatch(routerRedux.push(PATHS.meetingInfo));
                    }}
                  >
                    <FormattedMessage id="meeting_btn_create_normal_meeting" />
                  </span>
                  {meetingPolicy.cmmaMeetingState === 1 && (
                    <span
                      className="create-btn"
                      onClick={() => {
                        this.props.dispatch({
                          type: 'meetingInfo/set',
                          payload: { onlyVideo: 2, meeting: {} }
                        });
                        this.props.dispatch(
                          routerRedux.push(PATHS.meetingInfo)
                        );
                      }}
                    >
                      <FormattedMessage id="meeting_btn_create_video_meeting" />
                    </span>
                  )}
                </div>
              </div>
              {this.props.calendar.calenderMeetingData &&
                this.props.calendar.calenderMeetingData.list && (
                  <SearchView
                    conversionType={this.conversionType}
                    intl={intl}
                    dispatch={this.props.dispatch}
                    locale={locale}
                    holidays={holidays}
                    showTime={this.props.calendar.showTime}
                    timeType={timeType}
                    searchResults={this.props.calendar.calenderMeetingData}
                    createMeetingHandle={this.createMeetingHandle}
                    handleByClickDay={this.clickHandleByDay}
                    userInfo={this.props.userInfo}
                    meetingPolicy={meetingPolicy}
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/meeting/Index.js